module.exports = __webpack_public_path__ + "static/dolly3-f7ca7c38034764a1aec675ce46b55448.jpg";